import { prefixObjectValues } from '../../utils';
import additionalTermsForm from './additional-terms-form';
import facilityForm from './facility-form';
const PREFIX = 'listings';

export default {
  facilityForm: prefixObjectValues(facilityForm, PREFIX),
  additionalTermsForm: prefixObjectValues(additionalTermsForm, PREFIX),
};
